
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";


export default {
  name: "Employee",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker,
    VueTimepicker
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      decimal_separator: ".",
precision: 0,
      currency: "",
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      period: "",
      isShow: false,
      storeList: [],
      employeeList: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        employee_id: "",
        search: "",
        to_date: "",
        from_date: "",
        to_time: "",
        from_time: ""
      }
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      this.$api
        .getAPI({
          _action: "/report/employee/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj,
          _hide_loader: true
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_employee_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    getPeriod() {
      if (this.period == "Custom Period") {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/report/export_employees/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'employees.csv'})
    }
  },
  mounted() {

    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-2 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select
                class="form-control"
                v-model="period"
                @change="getPeriod()"
                aria-placeholder="all day"
              >
                <option value>{{$lang.messages.all_day}}</option>
                <option>{{$lang.messages.custome_period}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_employees}}</option>
                <option
                  v-for="employee in employeeList"
                  :key="employee.id"
                  :value="employee.id"
                >{{employee.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-right row mb-3">
          <div class="text-right col-md-6">
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 120px;"
              v-if="isShow"
            >
              <vue-timepicker
                v-model="filterObj.to_time"
                @change="getList(1)"
                :placeholder="$lang.messages.start_time"
                format="HH:mm"
              ></vue-timepicker>
            </div>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;"
            v-if="isShow"
          >
            <vue-timepicker
              v-model="filterObj.from_time"
              @change="getList(1)"
              :placeholder="$lang.messages.end_time"
              format="HH:mm"
            ></vue-timepicker>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="pink-tape py-1 mt-3">
                <div class="row">
                  <div class="col-lg-9 col-5 align-self-center">
                    <a
                      href="javascript:void(0)"
                      class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                      @click="getExport()"
                    >
                      {{$lang.messages.export}}
                      <i class="mdi mdi-download align-text-top"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'name')"
                      >{{$lang.messages.name}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'gross_sale')"
                      >{{$lang.messages.gross_sale}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'refund')"
                      >{{$lang.messages.refunds}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'discount')"
                      >{{$lang.messages.discounts}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'net_amount')"
                      >{{$lang.messages.net_sale}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'receipts')"
                      >{{$lang.messages.receipts}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'average_sale')"
                      >{{$lang.messages.average_sale}}</th>
                      <th
                        scope="col"
                        class="text-center sorting"
                        @click="sorting($event, 'customer')"
                      >{{$lang.messages.customers_signed_up}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in list" :key="item.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{item.name}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.gross_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.gross_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.refund"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.refund"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.discount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.discount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.net_amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.net_amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">{{item.receipts}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.average_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.average_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">{{item.customer}}</td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
